import styled from 'styled-components';

export const ComboBoxContainer = styled.div``;

export const GROUP_HEADER_ITEM_CSS = `
    background-color: transparent !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #6D6D6D;
    pointer-events: none;
    cursor: default;
    user-select: none;
    padding: 8px 16px 4px;
    border-bottom: none;
`;

export const CONTENT_WRAPPER_CSS = `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
`;

export const INJECTED_ICON_CSS = `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 0.875rem;
    height: 0.875rem;
    line-height: 0;
    color: #6D6D6D;
`;

export const DESCRIPTION_CSS = `
    font-weight: 400;
    font-size: 12px;
    color: #6D6D6D;
    margin-top: 4px;
    line-height: 1.4;
    display: block;
    width: 100%;
`;
